var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBxBxCreditCardFront = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    fill: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65 13H13C9.41525 13 6.5 15.9152 6.5 19.5V58.5C6.5 62.0848 9.41525 65 13 65H65C68.5848 65 71.5 62.0848 71.5 58.5V19.5C71.5 15.9152 68.5848 13 65 13ZM13 58.5V19.5H65L65.0033 58.5H13Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.125 35.75H30.875C31.306 35.75 31.7193 35.5788 32.024 35.274C32.3288 34.9693 32.5 34.556 32.5 34.125V27.625C32.5 27.194 32.3288 26.7807 32.024 26.476C31.7193 26.1712 31.306 26 30.875 26H21.125C20.694 26 20.2807 26.1712 19.976 26.476C19.6712 26.7807 19.5 27.194 19.5 27.625V34.125C19.5 34.556 19.6712 34.9693 19.976 35.274C20.2807 35.5788 20.694 35.75 21.125 35.75ZM19.5 45.5H39V52.0032H19.5V45.5ZM42.25 45.5H58.5V52.0032H42.25V45.5Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBxBxCreditCardFront);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/bx_bx-credit-card-front.b52b1e7bca49c992dd851be47c3e8fd2.svg";